import Typography from "../../atoms/Typography";

export default function AppFooter() {
  return (
    <footer>
      <a href="https://github.com/codechriscode">
        <Typography variant="spaced-caps">github/codechriscode</Typography>
      </a>
    </footer>
  );
}
